module.exports = __webpack_public_path__ + "img/TrollWarlord.898d6afa.png";